module.exports = __webpack_public_path__ + "static/media/coupon-img.c462bac8.jpeg";